import { useEffect } from 'react';
import { trackingService } from '../services/trackingService';

export default function TrackingScripts() {
  useEffect(() => {
    const loadTracking = async () => {
      try {
        const tracking = await trackingService.getActiveTracking();
        
        tracking.forEach(({ key, value }) => {
          if (key === 'google_analytics_id' && value) {
            // Google Analytics GA4
            const script1 = document.createElement('script');
            script1.async = true;
            script1.src = `https://www.googletagmanager.com/gtag/js?id=${value}`;
            document.head.appendChild(script1);
            
            const script2 = document.createElement('script');
            script2.innerHTML = `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${value}');
            `;
            document.head.appendChild(script2);
          }
          
          if (key === 'meta_pixel_id' && value) {
            // Meta Pixel
            const script = document.createElement('script');
            script.innerHTML = `
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '${value}');
              fbq('track', 'PageView');
            `;
            document.head.appendChild(script);
            
            const noscript = document.createElement('noscript');
            noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${value}&ev=PageView&noscript=1" />`;
            document.body.appendChild(noscript);
          }
          
          if (key === 'google_ads_id' && value) {
            // Google Ads
            const script1 = document.createElement('script');
            script1.async = true;
            script1.src = `https://www.googletagmanager.com/gtag/js?id=${value}`;
            document.head.appendChild(script1);
            
            const script2 = document.createElement('script');
            script2.innerHTML = `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${value}');
            `;
            document.head.appendChild(script2);
          }
          
          if (key === 'google_tag_manager_id' && value) {
            // Google Tag Manager
            const script1 = document.createElement('script');
            script1.innerHTML = `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${value}');
            `;
            document.head.appendChild(script1);
            
            const noscript = document.createElement('noscript');
            noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${value}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
            document.body.appendChild(noscript);
          }
          
          if (key === 'tiktok_pixel_id' && value) {
            // TikTok Pixel
            const script = document.createElement('script');
            script.innerHTML = `
              !function (w, d, t) {
                w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
                ttq.load('${value}');
                ttq.page();
              }(window, document, 'ttq');
            `;
            document.head.appendChild(script);
          }
          
          if (key === 'klaviyo_id' && value) {
            // Klaviyo
            const script = document.createElement('script');
            script.async = true;
            script.type = 'text/javascript';
            script.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${value}`;
            document.head.appendChild(script);
          }
        });
      } catch (error) {
        console.error('Error loading tracking:', error);
      }
    };
    
    loadTracking();
  }, []);

  return null;
}
